/**
* Banner Image JS
* -----------------------------------------------------------------------------
*
* All the JS for the Banner Image component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'banner-image',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.banner-image' ).each( function( index, element ) {
        const overlay = $( element ).find( '.banner-image__overlay' );
        const content = $( element ).find( '.banner-image__content' );
        const contentHeight = $( content ).outerHeight();

        gsap.set( overlay, {opacity: 0} );
        gsap.set( content, {y: `${contentHeight}px`} );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( element ),
            pin: true,
            anticipatePin: 0.5,
            once: true,
            onLeave: ( self ) => {
              const start = self.start;
              self.scroll( self.start );
              self.disable();
              self.animation.progress( 1 );
              ScrollTrigger.refresh();
              window.scrollTo( 0, start );
            },
            scrub: 0.5,
            start: 'top top',
            end: 'bottom 70%',
          },
        } );

        tl.to( $( overlay ), {
          opacity: 0.5, // property/value
          duration: 0.75, // duration e.g. 1s
        }, 0 );

        tl.to( $( content ), {
          y: 0, // property/value
          duration: 1.5, // duration e.g. 1s
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'banner-image', COMPONENT );
} )( app );
